<template>
  <div>
    <toolbar :buttons-display="buttonsDisplay"/>

    <div contenteditable="true"
         id="RTE__edition__field"
         :style="{ minHeight: height + 'px', borderColor }"
         @input="onUpdate"
    ></div>

    <footer id="RTE__footer__actions">
      <v-btn :color="cancelColor" @click.stop="onCancel" v-if="display.cancel">{{ cancelText }}</v-btn>
      <v-btn :color="validColor" @click.stop="onValid" v-if="display.valid">{{ validText }}</v-btn>
    </footer>
  </div>
</template>

<script>
import Toolbar from '../components/toolbar/toolbar'

export default {
  name: 'editor',
  components: { Toolbar },
  props: {
    borderColor: {
      type: String,
      required: false,
      default: 'rgba(0, 0, 0, 0.5)',
    },
    buttonsDisplay: {
      type: Object,
      required: false,
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
    cancelColor: {
      type: String,
      required: false,
      default: '#D77E75',
    },
    cancelText: {
      type: String,
      required: false,
      default: 'Annuler',
    },
    height: {
      type: Number,
      required: false,
      default: 500,
    },
    validColor: {
      type: String,
      required: false,
      default: '#47A4A9',
    },
    validText: {
      type: String,
      required: false,
      default: 'Valider',
    },
  },
  data: () => ({
    display: {},
    valueLocal: null
  }),
  watch: {
    value () {
      if (this.value !== this.valueLocal) {
        this.$el.children.namedItem('RTE__edition__field').innerHTML = this.value
        this.valueLocal = this.value
      }
    },
  },
  mounted () {
    this.$el.children.namedItem('RTE__edition__field').innerHTML = this.value
    this.valueLocal = this.value

    this.display = {
      cancel: true,
      valid: true,
      ...this.buttonsDisplay,
    }
  },
  methods: {
    onCancel () {
      this.$emit('cancel')
      this.$el.children.namedItem('RTE__edition__field').innerHTML = ''
      this.valueLocal = ''
    },
    onUpdate (event) {
      this.valueLocal = event.target.innerHTML
      this.$emit('input', event.target.innerHTML)
    },
    onValid () {
      this.$emit('valid', this.$el.children.namedItem('RTE__edition__field').innerHTML)
      this.$el.children.namedItem('RTE__edition__field').innerHTML = ''
      this.valueLocal = ''
    },
  },
}
</script>

<style lang="scss" scoped>
  #RTE__edition__field {
    border: 1px solid;
    padding: 5px;
  }

  #RTE__footer__actions {
    position: static;
    background-color: transparent;
    display: flex;
    justify-content: flex-end;
    padding: 10px 0;

    button:first-child {
      margin-right: 10px;
    }
  }
</style>
